import { ClassPlan } from 'modules/jogador/classes/types';
import { Card } from 'shared/components/ui/Card';
import { Badge } from 'shared/components/ui/Badge';
import { Button } from 'shared/components/ui/Button';
import { formatBRL } from 'shared/utils/format';
import { useToast } from 'shared/components/ui/Toast';

interface PlanCardProps {
  plan: ClassPlan;
}

export function PlanCard({ plan }: PlanCardProps) {
  const toast = useToast();

  return (
    <Card>
      <div className="flex items-center justify-between">
        <p className="text-xs font-semibold uppercase tracking-wide text-ink-secondary">
          Assinatura mensal
        </p>
        <Badge tone="success">{plan.status}</Badge>
      </div>

      <h2 className="mt-1 font-heading text-lg font-semibold text-ink">{plan.name}</h2>
      <p className="text-sm text-ink-secondary">{plan.scheduleLabel}</p>

      <p className="mt-3 text-sm text-ink-secondary">
        Próxima cobrança <span className="font-medium text-ink">{plan.nextBillingLabel}</span> · {formatBRL(plan.nextBillingAmount)}
      </p>
      <p className="text-sm text-ink-secondary">
        Vaga garantida até <span className="font-medium text-ink">{plan.guaranteedUntilLabel}</span>
      </p>

      <div className="mt-4 flex gap-3">
        <Button
          variant="ghost"
          className="flex-1"
          onClick={() =>
            toast({
              tone: 'info',
              title: 'Gerenciar assinatura',
              description: 'Em breve: pausar, cancelar e trocar a forma de pagamento.',
            })
          }
        >
          Gerenciar
        </Button>
        <Button
          variant="ghost"
          className="flex-1 border-primary bg-accent-soft"
          onClick={() =>
            toast({ title: 'Pedido de troca enviado', description: 'A arena vai sugerir turmas com vaga no seu nível.' })
          }
        >
          Trocar turma
        </Button>
      </div>
    </Card>
  );
}
